export default "__VITE_ASSET__DDKzZlqt__"